module.exports = __webpack_public_path__ + "static/media/correct.fbbd9650.svg";